import type { Game } from "../types/game";

export default function GameCard({
  game,
  onClick,
}: {
  game: Game;
  onClick: () => void;
}) {
  return (
    <button className="game-card" onClick={onClick} type="button">
      <div className="game-card-img">
        {game.imageUrl ? (
          <img src={game.imageUrl} alt={game.title} loading="lazy" />
        ) : (
          <div className="game-card-noimg">No image</div>
        )}
      </div>
      <div className="game-card-body">
        <div className="game-card-title">{game.title}</div>
        <div className="game-card-meta">
          {game.releaseYear ?? "—"}
          {game.genres.length > 0 && ` · ${game.genres.slice(0, 2).join(", ")}`}
        </div>
      </div>
    </button>
  );
}
